<template>
  <div class="flex flex-col">
    <h2>Reportes</h2>

    <div class="flex flex-col lg:flex-row gap-6 mt-6 items-start">
      <aside
        class="w-full lg:w-64 shrink-0 bg-white rounded-lg shadow-primary p-2 lg:sticky lg:top-4"
      >
        <nav class="flex lg:flex-col gap-1 overflow-x-auto">
          <router-link
            v-for="report in reports"
            :key="report.name"
            :to="{ name: report.name }"
            class="report-nav-item shrink-0"
            :class="[
              $route.name === report.name
                ? 'bg-primary-100 text-primary-600'
                : 'text-content-400 hover:bg-gray-50 hover:text-content-500',
            ]"
          >
            <p class="font-medium text-sm whitespace-nowrap lg:whitespace-normal">
              <span class="mr-1.5">{{ report.icon }}</span>{{ report.label }}
            </p>
            <p class="text-xs text-content-400 mt-0.5 hidden lg:block">
              {{ report.description }}
            </p>
          </router-link>
        </nav>
      </aside>

      <router-view class="flex-1 min-w-0 min-h-screen" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Reports",

  data() {
    return {
      reports: [
        {
          name: "biweekly",
          icon: "📆",
          label: "Bisemanal",
          description: "Cortes quincenales por franquicia",
        },
        {
          name: "monthly",
          icon: "📅",
          label: "Mensual",
          description: "Ventas, gastos y clientes por sucursal",
        },
        {
          name: "paymentHealth",
          icon: "💳",
          label: "Salud de Pagos",
          description: "Cobros, reintentos y suspensiones",
        },
        {
          name: "operational",
          icon: "⚙️",
          label: "Operativo",
          description: "Órdenes y operación de sucursales",
        },
        {
          name: "customerHealth",
          icon: "🩺",
          label: "Salud de Clientes",
          description: "Altas, bajas, planes activos y adquisición",
        },
        {
          name: "walletReport",
          icon: "👛",
          label: "Monedero",
          description: "Saldo por referidos: pasivo y redenciones",
        },
      ],
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "reports");
  },
};
</script>

<style scoped>
.report-nav-item {
  display: block;
  padding: 0.6rem 0.75rem;
  border-radius: 0.5rem;
  transition: all 0.15s;
}
</style>
